<template>
    <ui-page :title="title || page.title" :page="page" :backable="backable" ref="page">
        <div slot="drawer">
            <div class="header">
                <img class="logo" src="/static/img/project.svg">
            </div>
            <ui-list @itemClick="toggle()">
                <ui-list-item title="网站首页" to="/">
                    <ui-icon slot="left" value="home"/>
                </ui-list-item>
                <ui-list-item title="面板" to="/admin">
                    <ui-icon slot="left" value="home"/>
                </ui-list-item>
                <ui-list-item title="产品管理" to="/admin/products">
                    <ui-icon slot="left" value="home"/>
                </ui-list-item>
                <ui-list-item title="项目管理" to="/admin/projects">
                    <ui-icon slot="left" value="home"/>
                </ui-list-item>
            </ui-list>
        </div>
        <slot></slot>
    </ui-page>
</template>

<script>
    export default {
        data() {
            return {
                open: false,
                docked: true
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: 'default'
            },
            page: {
                type: Object,
                default() {
                    return {
                        title: '云设',
                        menu: [
                        ]
                    }
                }
            },
            backable: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            toggle() {
                console.log(this.$refs.page)
            },
            lock() {
                this.$storage.set('lock_password', null)
                this.$router.push('/lock')
            }
        }
    }
</script>

<style lang="scss" scoped>
.header {
    padding: 64px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.logo {
    display: block;
    width: 80px;
    margin: 0 auto;
}
.ui-position-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/admin-page/page.vue